
import * as _ from 'lodash'
export interface VariableDocumentT {
    key: string
    type: string
    value: any
}

export const variablesToObject = (variables: Array<VariableDocumentT>) => {
    let obj = {}
    if (!_.isArray(variables)) {
        return obj;
    }
    variables.map((variable: VariableDocumentT, index) => {
        if (variable.key && variable.key != "") {
            obj[variable.key] = variable.value
        }
    })

    return obj
}
//getVariableValue
export const getVariableValue = (key: string, variables: Array<VariableDocumentT>, defaultVariable = null): any => {
    if (!_.isArray(variables)) {
        return false;
    }
    const variable = variables.find((x) => x.key == key)
    if (variable) {
        return variable.value
    }
    if (defaultVariable) {
        return defaultVariable
    }
    return false;
}


// setValueVariables
export const setValueVariables = (key: string, value: any, variables: Array<VariableDocumentT>, defaultVariables: Array<VariableDocumentT> = null, typeVariable: string = ""): Array<VariableDocumentT> => {
    let cloneVariables = variables && _.isArray(variables) ? variables : defaultVariables
    if (!cloneVariables || !_.isArray(cloneVariables)) {
        return [];
    }
    let keyIsExists = false;
    let tempVariables = variables.map((item) => {
        if (item.key == key) {
            item.value = value
            keyIsExists = true;
        }
        return item;
    })

    if (!keyIsExists) {
        tempVariables.push({
            key: key,
            type: (typeVariable && typeVariable != "") ? typeVariable : 'any',
            value: value
        })
    }

    // console.log("variables", variables)
    return tempVariables
}